<template>
<div class="widgets">
	<div v-if="$store.userRole == 'Light'" class="project-dashboard-light-placeholder">
		<clock-in-timer v-if="$store.clockedIn"></clock-in-timer>
		<router-link v-else to="/punch-clock" class="light-punch-clock-btn">
			<i class="fa fa-clock"></i>
			<div class="light-punch-clock-btn-text">
				<div class="light-punch-clock-btn-title">CLOCK IN</div>
				<div class="light-punch-clock-btn-subtitle">Let's get started</div>
			</div>
		</router-link>

		<button type="button" class="light-do-form-btn" v-on:click="doCompanyForm" :disabled="!$store.project || !('id' in $store.project) || $store.company.is_freemium == 1">
			<i v-if="$store.company.is_freemium == 1" class="fa fa-lock"></i>
			<i v-else class="fa fa-clipboard-check"></i>
			<div class="light-do-form-btn-text">
				<div class="light-do-form-btn-title">DO FORM</div>
				<div class="light-do-form-btn-subtitle">Fill out a company form</div>
			</div>
		</button>
	</div>

	<template v-else>

		<project-kpi-widget v-if="(hasJobReadPerms && hasJobReadFinancialsPerm) || $store.userRole == 'Admin'">
			
		</project-kpi-widget>

		<widget v-if="$store.project" title="Project Timeline">
			<job-timeline :job="$store.project"
				job-type="project"
				weeks-back="1">
			</job-timeline>
		</widget>

		<div class="row">
			<!--
			<div class="col-12">
				<widget v-if="hasJobReadPerms && (hasJobReadFinancialsPerm || $store.userRole == 'Admin')" title="Revenue & Expenses">
					Make this an accordion Widget
					<project-revenue-graph v-if="'id' in $store.project" :project-id="$store.project.id" v-on:chartClick="$router.push('/project/'+$store.project.slug+'/reports/labour-progress')"></project-revenue-graph>
				</widget>
			</div>
			-->
			<div class="col-md-6">

				<widget title="Weather" icon="fa-cloud" class="row-padding">
					<weather-widget :lat="$store.project.lat" :lon="$store.project.long" :show-warnings="true"></weather-widget>
				</widget>

				<widget v-if="$store.project" title="Details" icon="fa-list" :header-button="getUserRoleType() == 'Admin' || hasModulePermWrite('Jobs') ? 'fa-pencil-alt' : false" v-on:headerButtonClick="editDetails" :no-padding="true">
					<table class="table table-striped table-sm mb-0">
						<thead></thead>
						<tbody>
							<tr>
								<th>Project #</th>
								<td>{{$store.project.job_num}}</td>
							</tr>
							<tr>
								<th>Project Name</th>
								<td>{{$store.project.job_name}}</td>
							</tr>
							<tr>
								<th>Category</th>
								<td>{{$store.project.Category ? $store.project.Category.name : ""}}</td>
							</tr>
							<tr v-if="$store.project.Customer">
								<th>Customer</th>
								<td>{{$store.project.Customer.name}}</td>
							</tr>
							<tr v-if="$store.project.address">
								<th>Address</th>
								<td>
									<template v-if="$store.project.suite">{{$store.project.suite}}-</template>{{$store.project.address}}<br>
										{{$store.project.city}},
										{{$store.project.province}}<br>
										{{$store.project.country}}<br>
										{{$store.project.postal_code}}<br>
								</td>
							</tr>
							<tr>
								<th>Date Landed</th>
								<td>{{$store.project.date_landed}}</td>
							</tr>
							<tr>
								<th>Start Date</th>
								<td>{{$store.project.start_date}}</td>
							</tr>
							<tr>
								<th>Description</th>
								<td>{{$store.project.description}}</td>
							</tr>
							<tr>
								<th>Distance From Office</th>
								<td>{{ convertedDistanceFromOffice }} {{distanceUnits}} </td>
							</tr>
							<tr>
								<th>Bonded</th>
								<td v-html="stripInlineEventHandlers($store.project.is_bonded == 1 ? '<i class=\'fa fa-check\'></i>' : '<i class=\'fa fa-times\'></i>')"></td>
							</tr>
							<tr>
								<th>Permit Required</th>
								<td v-html="stripInlineEventHandlers($store.project.permit_needed == 1 ? '<i class=\'fa fa-check\'></i>' : '<i class=\'fa fa-times\'></i>')"></td>
							</tr>
							<tr v-if="$store.project.permit_needed == 1">
								<th>Permit Notification #</th>
								<td>{{ $store.project.permit_notification_number }}</td>
							</tr>
							<tr>
								<th>Locates</th>
								<td v-if="'LocateTicket' in $store.project && $store.project.LocateTicket.filter(ticket => ticket.archived != 1).length > 0">
									<i class='fa fa-check'></i> (<router-link to="locates">{{ $store.project.LocateTicket.filter(ticket => ticket.archived != 1).length }} on file</router-link>)
								</td>
								<td v-else>None. <router-link to="locates">Add a locate...</router-link></td>
							</tr>
							<tr v-if="$store.project && 'UpdatedBy' in $store.project && $store.project.UpdatedBy">
								<th>Last Edited</th>
								<td>{{ $store.project.UpdatedBy.first_name }} {{ $store.project.UpdatedBy.last_name }} @ {{ formatDateTimeToLocal($store.project.edited_at) }}</td>
							</tr>
						</tbody>
					</table>

					<job-map v-if="showDashboardMap"
						:job-location="{lat:parseFloat($store.project.lat),lng:parseFloat($store.project.long)}" 
						:show-map="true" 
						:map-zoom="13"
						:check-in-tolerance="parseInt($store.project.check_in_tolerance)">
					</job-map>
					<button v-else class="btn btn-light" v-on:click="showDashboardMap = true">
						<i class="fa fa-map"></i>
						Show Map/Directions to Job Site
					</button>

				</widget>

				<widget v-if="mutatedProjectContacts.length > 0" title="Project Contacts" icon="fa-users">
					<table-list
						:records="mutatedProjectContacts"
						:fields="$store.contactFields"
						record-name="Contact"
						:hide-record-count="true">
					</table-list>
				</widget>

				<widget v-if="'JobNote' in $store.project && $store.project.JobNote.length > 0" title="Recent Notes" icon="fa-bar-chart">
					<ul class="list-group mb-2">
						<li v-for="(note,index) in $store.project.JobNote" v-if="index < 3" class="list-group-item">
							<h4 class="mb-0">{{note.subject}}</h4>
							<div class="mb-2"><small>{{formatDateTimeToLocal(note.updated_at)}}</small></div>
							<div v-html="stripInlineEventHandlers(note.note)"></div>
						</li>
					</ul>

					<div class="text-center"><router-link to="notes">Go to notes</router-link></div>
				</widget>

				<widget v-if="'JobChangeOrder' in $store.project && $store.project.JobChangeOrder"
					title="Outstanding Change Orders">

					<table-list record-name="Change Order"
						:fields="[
							{label: 'Change Order #',key:'coNumber',type:'link'},
							{label: 'Status',key:'quote_status'}
						]"
						:records="mutatedChangeOrders">
					</table-list>

				</widget>
			</div>
			<div class="col-md-6">

				<widget title="Personnel">
					<table-list	:fields="[
							{label: 'Role',key:'roleName'},
							{label: 'Name', key:'userName'},
							{label: 'Phone', key: 'userPhone'}
						]"
						:records="jobPersonnelList"
						:hide-record-count="true">
					</table-list>
				</widget>
				
				<widget :title="numUsersClockedIn + ' Users Currently Clocked In'" icon="fa-clock" :no-padding="true">
					<template slot="header">
						<button v-if="hasTimeLogWritePermsOnProject" 
							class="btn btn-success" 
							v-on:click="openGroupClockModal">
							<i class="fa fa-users"></i>
							<i class="fa fa-clock"></i>
							Group Clock In/Out
						</button>
					</template>
					<users-clocked-in-table 
						:key="$route.path"
						v-if="'id' in $store.project" 
						:filters="userClockedInFilters"
						:project-id="$store.project.id"
						:fetch-trigger="usersClockedInFetchTrigger"
						v-on:logsFetched="timeLogsFetched">
					</users-clocked-in-table>
				</widget>

				<job-schedule-timeline-widget v-show="jobScheduleTimelineWidgetDays && jobScheduleTimelineWidgetDays.length > 0"
					:project-id="$store.project.id"
					v-on:scheduleDaysSet="jobScheduleTimelineWidgetDays = $event">
				</job-schedule-timeline-widget>

				<!--<widget title="Messages" icon="fa-envelope" max-height="400px">
					<message-thread-card
						v-for="thread in threads"
						:key="thread.id"
						:thread="thread"
						v-on:click="selectThread(thread)">
					</message-thread-card>
				</widget>-->

				<widget v-if="hasJobReadPerms" title="Labour Summary" icon="fa-bar-chart">

					<div v-if="!timeLogReportGeneratingInProgress" class="d-flex flex-row justify-content-between align-items-center">
						<button class="btn btn-success" v-on:click="generateTimeLogReport">Generate</button>

						<div v-if="reportLastGenerated">
							Current on {{reportLastGenerated}}
						</div>
					</div>

					<progress-bar
						v-if="timeLogReportGeneratingInProgress"
						message="Generating Report..."
						:progress-percent="timeLogWidgetProgress">
					</progress-bar>

					<table v-else-if="timeLogWidgetGenerated" class="table">
						<thead>
							<th>Classification</th>
							<th class="text-right">Reg Hrs</th>
							<th class="text-right">OT 1.5x</th>
							<th class="text-right">OT 2.0x</th>
							<th class="text-right">OT 2.5x</th>
						</thead>
						<tbody>
							<tr v-for="classification in renderedTimeLogReport">
								<th>{{ classification.title }}</th>
								<td class="text-right">{{ classification.totals.regular_hours }}</td>
								<td class="text-right">{{ classification.totals.ot_15 }}</td>
								<td class="text-right">{{ classification.totals.ot_2 }}</td>
								<td class="text-right">{{ classification.totals.ot_25 }}</td>
							</tr>
						</tbody>
					</table>
				</widget>

				<widget v-if="$store.services.length > 0" title="Related Services">
					<table-list record-name="Related Service"
						:fields="[
							{label: 'Service #',key: 'job_num'},
							{label: 'Service Name',key: 'job_name'},
							{label: 'Status',key: 'displayStatus'}
						]"
						:records="mutatedRelatedServices"
						id-field="slug"
						has-edit="/service/{?}/dashboard">
					</table-list>
				</widget>

				<widget title="Project QR Code">
					<div class="d-flex justify-content-between mt-4">
						<vue-qr-code
							:params="{
								text: buildRedirectLink('project', $store.project.slug),
								width: 250,
								height: 250
							}"
							logo-url="/resources/icons/logo_dark_icon_192.png"
							logo-classes="p-1 rounded"
							:title="'Project - #'+$store.project.job_num"
							:show-copy-button="true">
						</vue-qr-code>
					</div>
				</widget>

				<!--<messages-widget v-if="'id' in $store.project" :job-id="$store.project.id"></messages-widget>-->

			</div>

		</div>

		<group-clock-modal v-if="'id' in $store.project" :visible="groupClockModalVisible"
			:project-id="$store.project.id"
			v-on:closeModal="groupClockModalVisible = false"
			v-on:usersClockedIn="usersClockedInFetchTrigger++"
			v-on:usersClockedOut="usersClockedInFetchTrigger++">
		</group-clock-modal>
	</template>
</div>
</template>

<script>
import Widget from "@/components/Widget"
import Spinner from "@/components/Spinner"
import MessageThreadCard from "@/layout_fragments/messages/MessageThreadCard"
import JobMap from "@/components/JobMap"
import ProgressBar from "@/components/ProgressBar"
import TableList from "@/components/TableList"
import VueQrCode from "@/components/VueQrCode.vue"
import JobTimeline from "@/components/super_components/JobTimeline"
import ProjectKpiWidget from "@/components/super_components/ProjectKpiWidget"
import JobScheduleTimelineWidget from "@/components/widgets/JobScheduleTimelineWidget"
import ProjectRevenueGraph from "@/components/super_components/ProjectRevenueGraph"
import MessagesWidget from "@/components/widgets/MessagesWidget"
import GroupClockModal from "@/components/super_components/GroupClockModal"
import WeatherWidget from "@/components/super_components/WeatherWidget"
import UsersClockedInTable from "@/components/super_components/UsersClockedInTable"
import ClockInTimer from "@/components/ClockInTimer"
import JobMixins from "@/mixins/JobMixins.js"
import ServiceMixins from "@/mixins/ServiceMixins.js"

export default {

	name: 'ProjectDashboard',
	components: {
		Widget,
		MessageThreadCard,
		UsersClockedInTable,
		JobMap,
		Spinner,
		WeatherWidget,
		ProgressBar,
		MessagesWidget,
		ProjectRevenueGraph,
		GroupClockModal,
		TableList,
		VueQrCode,
		JobScheduleTimelineWidget,
		JobTimeline,
		ProjectKpiWidget,
		ClockInTimer
	},
	mixins: [JobMixins,ServiceMixins],
	data() {
		return {
			timeLogs: [],
			invoices: null,
			relatedServices: [],
			classifications: [],
			numUsersClockedIn: 0,
			usersClockedInFetchTrigger: 0,
			userClockedInFilters: [['job_id',this.$store.project.id]],
			timeLogPage: 1,
			timeLogWidgetGenerated: false,
			timeLogReportGeneratingInProgress: false,
			timeLogWidgetProgress: 0,
			timeLogReportLastGenerated: localStorage.timeLogReportLastGenerated,
			timeLogReportProjectId: localStorage.timeLogReportProjectId,
			renderedTimeLogReport: [],
			showDashboardMap: false,
			groupClockModalVisible: false,
			jobScheduleTimelineWidgetDays: null
		}
	},
	watch: {
		'$store.project'() {
			let vm = this

			this.fetchData()
			this.setCachedTimeLogReport()

			vm.userClockedInFilters = [['job_id',vm.$store.project.id]]	

		},
	},
	computed: {
		hasJobReadPerms() {
			if (this.hasModulePermRead('Jobs'))
				return true 

			return this.hasRoleBasedPermission("project",this.$store.project.id,"read_perms")
		},
		hasJobReadFinancialsPerm() {
			if (this.hasModulePermRead('Jobs'))
				return true 

			return this.hasRoleBasedPermission("project",this.$store.project.id,"read_financials")
		},
		reportLastGenerated() {
			if ("timeLogReportLastGenerated" in localStorage && localStorage.timeLogReportJobId == this.$store.project.id)
				return this.formatDate(localStorage.timeLogReportLastGenerated)
			else if (this.timeLogReportLastGenerated && this.timeLogReportJobId == this.$store.project.id)
				return this.formatDate(this.timeLogReportLastGenerated)
			else
				return false
		},
		mapsSrc() {
			let address_query = this.$store.project.address+"+"+this.$store.project.city+"+"+this.$store.project.province+"+"+this.$store.project.country+"+"+this.$store.project.postal_code

			return 'https://www.google.com/maps/embed/v1/place?key='+this.$store.GoogleEmbedAPIkey+"&q="+address_query+"&zoom=12"
		},
		hasTimeLogWritePermsOnProject() {
			let vm = this

			if (this.hasModulePermWrite("TimeLogs"))
				return true;
			else {
				//check role perms
				if ("JobPersonnelRole" in this.$store.userDetails && this.$store.userDetails.JobPersonnelRole) {
					return this.$store.userDetails.JobPersonnelRole.find(role => role.job_id == vm.$store.project.id && "write_timelogs" in role && role.write_timelogs == 1)
				}
				else return false
			}
		},
		jobPersonnelList() {
			let vm = this

			let list = []
			if ("User" in this.$store.project) {
				list = this.$store.project.User.map(user => {
					user.userName = user.first_name+" "+user.last_name
					user.userPhone = user.phone_mobile
					
					user.roleName = ""

					if (user.personnel_role_id > 0) {
						let role = vm.$store.jobPersonnelRoles.find(role => role.id == user.personnel_role_id)

						if (role)
							user.roleName = role.title
					}

					return user
				})

			}

			return list
		},
		mutatedProjectContacts() {
			let vm = this

			if ("JobContact" in this.$store.project) {
				return this.$store.project.JobContact.filter(contact => "Contact" in contact && contact.Contact).map(contact => {

					if (contact.Contact && contact.Contact) {
						contact.name = contact.Contact.name
						
						contact.phone = {
							text: contact.Contact.phone,
							link: "tel:"+contact.Contact.phone
						}

						contact.email = {
							text: contact.Contact.email,
							link: "mailto:"+contact.Contact.email
						}

						if ("Company" in contact.Contact && contact.Contact.Company)
							contact.company = contact.Contact.Company.name
						else
							contact.company = ""
					}

					contact.role = contact.role

					return contact
				})
			}
			else
				return []
		},
		mutatedChangeOrders() {
			let vm = this

			if (!("JobChangeOrder" in this.$store.project) || !this.$store.project.JobChangeOrder)
				return []

			return this.$store.project.JobChangeOrder.map(co => {
				co.coNumber = {}
				co.projectNum = {}

				co.coNumber = {
					text: "CO-" + vm.$store.project.job_num + "-" + co.quote_num,
					link: "/project/" + vm.$store.project.slug + "/change-orders/" + co.slug
				}

				return co
			})
		},
		mutatedRelatedServices() {
			let vm = this

			let completedStatuses = vm.getCompleteStatuses()

			return this.$store.services.map(service => {
				if (!service.assigned_to && completedStatuses.indexOf(service.status) == -1) 
					service.displayStatus = "Draft"
				else if (service.status == "" || !service.status || service.status == "Dispatched")
					service.displayStatus = "Dispatched"
				else if (vm.$store.serviceFilterArchiveValue == "reviewed") {
					//sort out which is "completed" and which is "reviewed"
					service.displayStatus = "Reviewed"
				}
				else if (vm.$store.serviceFilterArchiveValue == 'completed') {
					let reviewed = true
					if (service.TimeLog && service.TimeLog.forEach(log => {
						if (log.submitted_by == 0)
							reviewed = false
					}))

					if (reviewed) 
						service.displayStatus = "Reviewed"
				}

				return service
			})
		},
		convertedDistanceFromOffice() {
			if (this.companyIsAmerican) {
				let miles = +this.$store.project.distance_from_office / 1.61
				return miles.round(0)
			}
			else
				return this.$store.project.distance_from_office
		},
		distanceUnits() {
			if (this.companyIsAmerican) 
				return "mi"
			return "km"
		}
	},
	methods: {
		doCompanyForm() {
			this.$bus.$emit("doCompanyForm", {job_id: this.$store.project.id})
		},
		setJobReadPerms() {
			let vm = this
			if ("id" in this.$store.project) {
				this.hasJobPerm("read_perms",this.$store.userDetails.id,this.$store.project.id).then(response => {
					vm.hasJobReadPerms = response
				})
				this.hasJobPerm("read_financials",this.$store.userDetails.id,this.$store.project.id).then(response => {
					vm.hasJobReadFinancialsPerm = response
				})
			}
			else {
				vm.hasJobReadFinancialsPerm = false
				vm.hasJobReadPerms = false
			}
		},
		generateTimeLogReport() {
			this.timeLogReportGeneratingInProgress = true
			this.fetchAllTimeLogPages()
		},
		timeLogsFetched(logs) {
			this.numUsersClockedIn = logs.length
		},
		editDetails() {
			this.$router.push("/project/"+this.$route.params.id+"/details")
		},
		selectThread(thread) {
			this.$store.projectActiveThread = thread
		},
		logsToSummary() {
			let vm = this

			// Use a copy so we don't mutate this.classifications (avoids duplicate rows on re-generate)
			let classifications = [...this.classifications, {
				id: 0,
				title: "Unclassified",
			}]

			let columnTotals = {
				reg: 0,
				ot_15: 0,
				ot_2: 0,
				ot_25: 0
			}

			classifications = classifications.map(classification => {
				let regHrsTotal = 0;
				let overtimeHrs15xTotal = 0
				let overtimeHrs2xTotal = 0
				let overtimeHrs25xTotal = 0

				vm.timeLogs.forEach(log => {

					let logClassificationObj = false
					try {
						logClassificationObj = JSON.parse(log.classification_json)
					}
					catch (ex) {}

					if (((!logClassificationObj || logClassificationObj.length == 0) && classification.id == 0) || (logClassificationObj.id == classification.id)) {
						regHrsTotal += +log.regular_hours
						overtimeHrs15xTotal += +log.overtime_hours_15x
						overtimeHrs2xTotal += +log.overtime_hours_2x
						overtimeHrs25xTotal += +log.overtime_hours_25x
					}
				})

				columnTotals.reg += regHrsTotal
				columnTotals.ot_15 += overtimeHrs15xTotal
				columnTotals.ot_2 += overtimeHrs2xTotal
				columnTotals.ot_25 += overtimeHrs25xTotal

				classification.totals = {
					regular_hours: regHrsTotal,
					ot_15: overtimeHrs15xTotal,
					ot_2: overtimeHrs2xTotal,
					ot_25: overtimeHrs25xTotal
				}

				return classification
			})

			classifications = classifications.filter(classification => {
					if (classification.totals.regular_hours > 0 || classification.totals.ot_15 > 0 || classification.totals.ot_2 > 0 || classification.totals.ot_25 > 0)
						return true
				})

			//push totals row
			classifications.push({
				title: "Totals",
				totals: {
					regular_hours: columnTotals.reg,
					ot_15: columnTotals.ot_15,
					ot_2: columnTotals.ot_2,
					ot_25: columnTotals.ot_25
				}
			})

			return classifications
		},
		setCachedTimeLogReport() {
			let vm = this

			//check if there is a time log report already generated for today in localStorage
			if ("timeLogReportLastGenerated" in localStorage && localStorage.timeLogReportLastGenerated == this.moment().format("YYYY-MM-DD") && localStorage.timeLogReportJobId == this.$store.project.id) {
				//pull it from localstorage
				vm.timeLogWidgetGenerated = true
				try {
					vm.renderedTimeLogReport = JSON.parse(localStorage.timeLogReport)
				}
				catch(ex) {
					vm.timeLogWidgetGenerated = false
				}
			}
		},
		closeGroupClockModal() {
			this.groupClockModalVisible = false
		},
		openGroupClockModal() {
			let vm = this

			this.groupClockModalVisible = true
		},
		fetchAllTimeLogPages() {
			let vm = this

			vm.timeLogs = []

			let page = 1

			vm.fetchTimeLogPage(page).then(response => {
				let numPages = response.meta.num_pages

				let cntResolves = 1;

				vm.timeLogWidgetProgress = 1;

				vm.timeLogs = response.data

				if (numPages > 1) {

					for (var p = 2; p <= numPages; p++) {
						vm.fetchTimeLogPage(p).then(response => {

							cntResolves++

							vm.timeLogWidgetProgress = Math.floor(cntResolves / numPages * 100)

							if (response)
								vm.timeLogs = vm.timeLogs.concat(response.data)

							if (vm.timeLogWidgetProgress >= 100) {
								//COMPLETE

								vm.timeLogWidgetGenerated = true
								vm.renderedTimeLogReport = vm.logsToSummary()
								localStorage.timeLogReport = JSON.stringify(vm.renderedTimeLogReport)
								localStorage.timeLogReportJobId = vm.$store.project.id
								localStorage.timeLogReportLastGenerated = vm.moment().format("YYYY-MM-DD")

								vm.timeLogReportLastGenerated = vm.moment().format("YYYY-MM-DD")
								vm.timeLogReportGeneratingInProgress = false
							}
						})
					}
				}
				else {

					vm.timeLogWidgetGenerated = true
					vm.renderedTimeLogReport = vm.logsToSummary()
					localStorage.timeLogReport = JSON.stringify(vm.renderedTimeLogReport)
					localStorage.timeLogReportJobId = vm.$store.project.id
					localStorage.timeLogReportLastGenerated = vm.moment().format("YYYY-MM-DD")

					vm.timeLogWidgetProgress = 100
					vm.timeLogReportLastGenerated = vm.moment().format("YYYY-MM-DD")
					vm.timeLogReportGeneratingInProgress = false
				}
			})
			
		},
		fetchTimeLogPage(page) {
			let vm = this

			let params = {
				filters: [
					["job_id",this.$store.project.id],
					["submitted_by >",0]
				],
				page: page
			}

			return new Promise((resolve,reject) => {
				vm.getJSON("TimeLog/get",params).then(response => {

					resolve(response)
				})
			})
		},
		fetchRelatedServices() {
			let vm = this
			return new Promise((resolve,reject) => {
				if ("id" in this.$store.project) {
					vm.fetchServices(false,[
							["job_id",this.$store.project.id]
						],
						["id","slug","job_num","job_name","status"]
					).then(response => {
						resolve(response)
					})
				}
				else
					resolve({})
			})
		},
		
		fetchData() {
			this.spinner(true)

			let vm = this

			let timeLogFilters = JSON.stringify([
				["job_id",this.$store.project.id]
			])

			let timeLogInclude = JSON.stringify([
				{
					model: "User",
					include: ["EmployeeClassification"]
				}
			])

			let threadInclude = JSON.stringify(["User","Job"])

			let threadFilters = JSON.stringify([
				["Members.id",this.$store.userDetails.id],
				["job_id",this.$store.project.id]
			])

			let promises = [
				this.getJSON("EmployeeClassification/get"),
			]

			if (!this.$store.timeLogSettings  || !("id" in this.$store.timeLogSettings))
				promises.push(this.getJSON("TimeLogSetting/get"))

			this.fetchJobPersonnelRoles()

			this.fetchRelatedServices()

			Promise.all(promises).then(responses => {
				vm.spinner(false)

				vm.classifications = responses[0].data

				if (responses.length == 2)
					vm.$store.timeLogSettings = responses[1].data[0]
			})
		}
	},
	created() {
		//clear out services list to make room for populating related services (don't want to show non-related services in widget)
		this.$store.services = []

		
		this.setCachedTimeLogReport()

		this.fetchData()

	}

}
</script>

<style type="text/css" scoped>
	.list-group-item pre {
		font-family: inherit;
		white-space: pre-wrap;
		margin-bottom: 0;
	}

	.light-punch-clock-btn {
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: var(--brand-primary-color);
		color: #fff;
		border-radius: 16px;
		padding: 1.25rem 1.5rem;
		margin-bottom: 1.25rem;
		text-decoration: none;
		width: 100%;
	}

	.light-punch-clock-btn:hover {
		color: #fff;
		text-decoration: none;
		opacity: 0.92;
	}

	.light-punch-clock-btn .fa-clock {
		font-size: 2.5rem;
		margin-right: 1rem;
	}

	.light-punch-clock-btn-text {
		display: flex;
		flex-direction: column;
		line-height: 1.2;
	}

	.light-punch-clock-btn-title {
		font-weight: 700;
		font-size: 1.5rem;
		letter-spacing: 0.02em;
	}

	.light-punch-clock-btn-subtitle {
		font-size: 0.95rem;
		font-weight: 400;
	}

	.light-do-form-btn {
		display: flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		background-color: #2e10a3;
		color: #fff;
		border: 0;
		border-radius: 16px;
		padding: 1.25rem 1.5rem;
		margin-bottom: 1.25rem;
		width: 100%;
		cursor: pointer;
	}

	.light-do-form-btn:hover:not(:disabled) {
		color: #fff;
		opacity: 0.92;
	}

	.light-do-form-btn:disabled {
		opacity: 0.65;
		cursor: not-allowed;
	}

	.light-do-form-btn > .fa {
		font-size: 2.5rem;
		margin-right: 1rem;
	}

	.light-do-form-btn-text {
		display: flex;
		flex-direction: column;
		line-height: 1.2;
		text-align: left;
	}

	.light-do-form-btn-title {
		font-weight: 700;
		font-size: 1.5rem;
		letter-spacing: 0.02em;
	}

	.light-do-form-btn-subtitle {
		font-size: 0.95rem;
		font-weight: 400;
	}

	@media (max-width: 550px) {
		.widgets {
			margin-left: 15px;
			margin-right: 15px;
		}

		.light-punch-clock-btn,
		.light-do-form-btn {
			margin-left: -15px;
			margin-right: -15px;
			width: calc(100% + 30px);
		}
	}
</style>